import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common'
import ptBr from '@angular/common/locales/pt'

import { AuthGuard } from './authentication/auth.guard'
import { Interceptor } from './authentication/httpInterceptor'
import { NotificationBuilder } from './shared/notificationBuilder'
import { StoreNameObservable } from './helpers/storeNameObservable'

import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressModule } from 'ngx-progressbar'
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgxPaginationModule } from 'ngx-pagination'; // Módulo da dependência de paginação
import { AppRoutes } from './app.routing'
import { AppComponent } from './app.component';
import { Configuration } from './app.constants'

import { PolenSidebarModule } from './sidebar/sidebar.module';
import { FixedPluginModule } from './shared/fixedplugin/fixedplugin.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { OpenLayoutComponent } from './layouts/open/open-layout.component';
import { SetupTutorialComponent } from './setup-tutorial/setup-tutorial.component'
import { ReferralComponent } from './referral/referral.component';
import { CustomizationComponent } from './customization/customization.component';
import { TransparencyComponent } from './transparency/transparency.component';
import { HelpCentralComponent } from './help-central/help-central.component';
import { NgoSelectorComponent } from './shared/ngo-selector/ngo-selectorcomponent';
import { StoreUserComponent } from './storeUsers/storeUsers.component';
import { CompreDoeComponent } from './compredoe/compredoe.component';
import { SetupComponent } from './setup/setup.component';
import { ScriptComponent } from './setup/script/script.component';

import { DashboardService } from './dashboard/dashboard.service';
import { SolutionsService } from './json/solutionsJson.service'
import { DepositTransferService } from './services/depositTransfer.service';
import { RegisterService } from './services/register.service';
import { PlatformJsonService } from './json/platformJson.service';
import { CausesService } from './causes/causes.service';
import { StoreUserService } from './storeUsers/storeUser.service';
import { BankCodeService } from './services/bankcode.service';
import { AuthenticationService } from './authentication/authentication.service'
import { ProfileService } from './profile/profile.service'
import { NgoService } from './ngo/ngo.service';
import { HelperService } from './services/helper.service';
import { HttpService } from './services/http.service';



// import { MatchFundingComponent } from "./match-funding/match-funding.component";
// import { MatchFundingService } from "./match-funding/match-funding.service";
// import { StepSelectNgoComponent } from "./match-funding/step-select-ngo/step-select-ngo.component";
// import { StepConfigValueComponent } from "./match-funding/step-config-value/step-config-value.component";
// import { StepReviewDataComponent } from "./match-funding/step-review-data/step-review-data.component";


registerLocaleData(ptBr)

@NgModule({
   imports: [
      DashboardModule,
      BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      AppRoutes,
      PolenSidebarModule,
      NavbarModule,
      FooterModule,
      FixedPluginModule,
      HttpClientModule,
      NgxSmartModalModule.forRoot(),
      NgProgressModule.withConfig({
         color: "#9752a2",
         spinnerPosition: "left",
      }),
      NgProgressHttpModule,
      NgxPaginationModule,
      SharedModule,

   ],
   declarations: [
      AppComponent,
      AdminLayoutComponent,
      AuthLayoutComponent,
      OpenLayoutComponent,
      StoreUserComponent,
      SetupTutorialComponent,
      ReferralComponent,
      CustomizationComponent,
      TransparencyComponent,
      HelpCentralComponent,
      NgoSelectorComponent,
      CompreDoeComponent,
      SetupComponent,
      ScriptComponent
   ],
   bootstrap: [
      AppComponent
   ],
   providers: [
      {
         provide: LOCALE_ID,
         useValue: "pt"
      },
      {
         provide: LocationStrategy,
         useClass: HashLocationStrategy
      },
      HttpService,
      HelperService,
      BankCodeService,
      SolutionsService,
      ProfileService,
      DashboardService,
      NgoService,
      CausesService,
      DepositTransferService,
      RegisterService,
      AuthGuard,
      Configuration,
      AuthenticationService,
      StoreUserService,
      NotificationBuilder,
      PlatformJsonService,
      StoreNameObservable,
      {
         provide: HTTP_INTERCEPTORS,
         useClass: Interceptor,
         multi: true
      },
      // {
      //    provide: HTTP_INTERCEPTORS,
      //    useClass: NgProgressInterceptor,
      //    multi: true
      // }
   ]
})

export class AppModule { }
